import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { REACT_QUERY_KEY } from "~/core/constants/common";

import { useGlobalCommandbarStore } from "../store";
import { CommandbarFilterTabType, CommandbarItemType } from "../types/common";

import { useStaticCommandItems } from "./useStaticCommandItems";

export const useCommandbarCommandItems = () => {
  const { commandbarStaticCommands } = useStaticCommandItems();

  const searchQuery = useGlobalCommandbarStore(st => st.searchQuery);
  const setSearchQuery = useGlobalCommandbarStore(st => st.setSearchQuery);
  const activeFilterTab = useGlobalCommandbarStore(st => st.activeFilterTab);
  const setActiveFilterTab = useGlobalCommandbarStore(
    st => st.setActiveFilterTab,
  );
  const setActiveCommandbarItemId = useGlobalCommandbarStore(
    st => st.setActiveCommandbarItemId,
  );
  const setCommandbarCommandItems = useGlobalCommandbarStore(
    st => st.setCommandbarCommandItems,
  );
  const setLoadingCommandbarItems = useGlobalCommandbarStore(
    st => st.setLoadingCommandbarItems,
  );
  const isOpenGlobalCommandbar = useGlobalCommandbarStore(
    st => st.isOpenGlobalCommandbar,
  );

  const { data: searchCommandbarData, isLoading: loadingSearchCommandbarData } =
    useQuery({
      queryKey: [
        REACT_QUERY_KEY.COMMANDBAR_SEARCH_COMMANDS,
        searchQuery,
        activeFilterTab,
      ],
      queryFn: async ({ queryKey }) => {
        const [_, searchQuery, activeFilter] = queryKey;
        const searchQueryLower = searchQuery.toLowerCase();
        const shouldFilterByObjectType =
          activeFilter !== CommandbarFilterTabType.ALL;

        const staticItemsResult = commandbarStaticCommands.filter(item => {
          let matchedFilter = true;

          if (shouldFilterByObjectType) {
            if (activeFilter === CommandbarFilterTabType.COMMAND) {
              matchedFilter = item.type === CommandbarItemType.COMMAND;
            } else {
              matchedFilter = item.objectType === activeFilter;
            }
          }

          const matchedLabel = item.label
            .toLowerCase()
            .includes(searchQueryLower);

          return matchedFilter && matchedLabel;
        });

        return staticItemsResult;
      },
    });

  useEffect(() => {
    if (!isOpenGlobalCommandbar) {
      setSearchQuery("");
      setActiveFilterTab(CommandbarFilterTabType.ALL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenGlobalCommandbar]);

  useEffect(() => {
    const notSearchQuery = searchQuery?.trim().length === 0;
    const notActiveFilter = activeFilterTab === CommandbarFilterTabType.ALL;

    const items =
      notSearchQuery && notActiveFilter
        ? commandbarStaticCommands.slice(0, 3)
        : searchCommandbarData || [];

    setCommandbarCommandItems(items);
    if (items.length > 0) {
      setActiveCommandbarItemId(items[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchCommandbarData, searchQuery]);

  useEffect(() => {
    setLoadingCommandbarItems(loadingSearchCommandbarData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingSearchCommandbarData]);
};
